<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">智能锁权限绑定</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="设备名">
          <el-input v-model="formInline.device_name" clearable :placeholder="`请输入`"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.device_status" clearable placeholder="请选择">
            <el-option label="在线" value="online"></el-option>
            <el-option label="离线" value="offline"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="设备名">
        </custom-table-column>
        <custom-table-column prop="devSerialNum" label="序列号">
        </custom-table-column>
        <custom-table-column prop="statusText" label="设备状态">
        </custom-table-column>
        <custom-table-column prop="deviceModel" label="设备型号">
        </custom-table-column>
        <custom-table-column prop="deviceType" label="设备类型">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditNew(scope.row, ['id'], async () => handleEditInit(scope.row))"
              size="small">绑定老师</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="绑定老师" :visible.sync="centerDialogVisible" width="586px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="选择老师" prop="bind_user_id_arr">
          <el-select v-model="ruleForm.bind_user_id_arr" clearable style="width:360px;" :multiple-limit="50" filterable
            multiple reserve-keyword :loading="loading" remote :remote-method="remoteMethod" placeholder="请输入名称搜索">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', updateMethod)">绑定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate],
  data() {
    return {
      formInline: {
        device_name: '',
        device_status: ''
      },
      levell: [1, 2, 3],
      loading: false,
      ruleForm: {
        bind_user_id_arr: [],
        lock_code: '',
      },
      rules: {
        bind_user_id_arr: [{ required: true, message: `请选择`, trigger: 'change' }],
      },
      users: []
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {

    async handleEditInit(row) {
      this.ruleForm.lock_code = row.indexCode;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock-user/info', 'get', { lock_code: row.indexCode });
      if (res.code == 0 && res.data && res.data.length) {
        this.ruleForm.bind_user_id_arr = res.data.map(item => {
          if (JSON.stringify(this.users).indexOf(item.user_id) == -1) {
            this.users.push({ id: item.user_id, name: item.name, number: item.number })
          }
          return item.user_id
        });

      } else {
        this.ruleForm.bind_user_id_arr = [];
      }
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      this.loading = false;
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
      }
    },

    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      params.bind_user_id_arr = params.bind_user_id_arr.filter(item => item != null).join(',');
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock-user/bind', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `设置成功!`,
        });
      }
      this.clearState();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less">
.pageHeader:before {
  width: var(--width);
}

.lock-box {
  text-align: center;
  padding: 24px 0 32px;

  span {
    padding: 6px;
    margin: 4px 8px;
    font-size: 22px;
    border-radius: 4px;
    // text-decoration: underline;
    border: 1px solid #cfcfcf;
  }
}

.el-cascader-node {
  height: auto !important;
  line-height: 2;
}

.el-cascader__dropdown {
  max-width: 100% !important;
  overflow: auto;
}

.el-cascader-node__label {
  line-height: 1.2;
}

.cascader-tip {
  color: rgb(132, 146, 166);
  font-size: 13px;
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 12px;
}
</style>
